

































import Engine, { Faction, Player, Resource as ResourceEnum } from "@gaia-project/engine";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { showIncome } from "../../data/resources";
import Resource from "../Resource.vue";
import PowerBowl from "./PowerBowl.vue";

@Component<PowerBowls>({
  components: {
    Resource,
    PowerBowl,
  },
})
export default class PowerBowls extends Vue {
  @Prop()
  player: Player;

  get engine(): Engine {
    return this.$store.state.data;
  }

  get showIncome() {
    return showIncome(this.engine, this.player);
  }

  get isTerran() {
    return this.player.faction === Faction.Terrans;
  }

  get r() {
    return 2;
  }

  get spacing() {
    return 1.1;
  }

  get sin60() {
    return 0.86602540378;
  }

  income(resource: ResourceEnum) {
    return this.player.resourceIncome(resource);
  }
}
